import axiosInstance from "../../api/axiosInstance";

export const fetchTournamentsListAPI = async ({ page = 1, limit = 10 } = {}) => {
  const params = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });
  const response = await axiosInstance.get(
    `adminCommentsReports/admin/tournament-comments/tournaments-list?${params.toString()}`,
  );
  return response.data;
};

export const fetchTournamentCommentsAPI = async ({
  tournamentId,
  search,
  page = 1,
  limit = 20,
}) => {
  const params = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });
  if (tournamentId) {
    params.append("tournamentId", tournamentId);
  }
  if (search && search.trim()) {
    params.append("search", search.trim());
  }

  const response = await axiosInstance.get(
    `adminCommentsReports/admin/tournament-comments?${params.toString()}`,
  );

  return response.data;
};

export const deleteCommentDirectAPI = async (commentId) => {
  const response = await axiosInstance.delete(
    `adminCommentsReports/admin/tournament-comments/${commentId}`,
  );

  return response.data;
};

export const deleteAllUserCommentsAPI = async (userId, tournamentId) => {
  const response = await axiosInstance.delete(
    `adminCommentsReports/admin/tournament-comments/user/${userId}/tournament/${tournamentId}`,
  );

  return response.data;
};

export const banUserFromCommentingAPI = async (userId, tournamentId) => {
  const response = await axiosInstance.patch(
    `adminCommentsReports/admin/tournament-comments/ban-user`,
    { userId, tournamentId },
  );

  return response.data;
};
